import { useEffect, useState } from 'react';

import { DuplicateEntityReplacedDialog } from 'components/PromptDialog/DuplicateEntityReplacedDialog';
import { useDialogStatus } from 'hooks/common';
import { duplicateEntityHandler, DuplicateEntityInfo } from 'utils/duplicateEntityHandler';

export const DuplicateEntityReplacement = () => {
  const [duplicateInfo, setDuplicateInfo] = useState<DuplicateEntityInfo | null>(null);
  const { isOpen, onShow, onHide } = useDialogStatus();

  useEffect(() => {
    duplicateEntityHandler.setOnDuplicateEntityFound(info => {
      setDuplicateInfo(info);
      onShow();
    });

    return () => {
      duplicateEntityHandler.clearCallback();
      onHide();
    };
  }, [onHide, onShow]);

  const handleDialogClose = () => {
    onHide();
    setDuplicateInfo(null);
  };

  return (
    isOpen &&
    duplicateInfo && (
      <DuplicateEntityReplacedDialog
        isOpen={isOpen}
        onHide={handleDialogClose}
        duplicateId={duplicateInfo.duplicateId}
        originalId={duplicateInfo.originalId}
      />
    )
  );
};
